export default __webpack_public_path__ + "static/media/screen1.5767e488.png";